// import React, { useRef } from 'react'
// import {Login} from '../components/Login'
// import { signInWithEmailAndPassword } from 'firebase/auth'
// import { auth } from '../utils/firebase'

// export const SignIn = () => {
//     const emailRef = useRef()
//     const password = useRef()

//     const login = async ()=> {

//         try{
//             await signInWithEmailAndPassword(auth, emailRef.current.value, password.current.value)
//             .then((user)=>{
//                 if(user){
//                     window.location = "/dashboard "
//                     console.log(user)
//                 }
//             })
  
//         }
//         catch(error){
//             alert(error.message)
//         }
//     }
//   return (
//     <div>
       
//     <Login 
//         title = "Sign in"
//         button = "Sign in"
//         href = "/signup"
//         link = "Sign up"
//         headerStatement = "Need an account?"
//         emailInput = {emailRef}
//         passwordInput = {password}
//         btnFunction = {login}
//     />
// </div>
//   )
// }
import { signInWithEmailAndPassword } from 'firebase/auth'
import React, { useRef } from 'react'
import { Login } from '../components/Login'
import { auth } from '../utils/firebase'


export const SignIn = () => {
    // Holds two references
    const emailRef = useRef()
    const passwordRef = useRef()


    const login = async () => {
      try {
        await signInWithEmailAndPassword(auth,emailRef.current.value,passwordRef.current.value)
        .then((user)=> {
          if(user) {
            window.location = "/dashboard"
          }
        })
      }
      catch(error) {
        alert(error.message)
      }
    }

  return (
    <div>
        <Login 
            title = "Sign in"
            button = "Sign in"
            href = "/signup"
            link = "Sign up"
            headerStatement = "Need an account?"
            emailInput = {emailRef}
            passwordInput = {passwordRef}
            btnFunction = {login}
        />
    </div>
  )
}










